module.exports = __webpack_public_path__ + "img/farming_14.b67b9514.png";